import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { rupiah } from "@/lib/format";
import { ResponsiveContainer, ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from "recharts";
import ChartRangeFilter, { rangeLabel } from "@/components/app/ChartRangeFilter";

const fmtAxis = (v) => {
  const a = Math.abs(v);
  if (a >= 1_000_000) return `${(v / 1_000_000).toFixed(a >= 10_000_000 ? 0 : 1)}jt`;
  if (a >= 1_000) return `${(v / 1_000).toFixed(0)}rb`;
  return `${v}`;
};

/** Grafik tren pemasukan vs pengeluaran dengan filter rentang (dipakai di Dashboard Keuangan Pribadi). */
export default function TrendKeuanganChart({ title = "Tren Pemasukan vs Pengeluaran", netLabel = "Selisih", testid = "pribadi-trend-chart" }) {
  const [range, setRange] = useState({ key: "default", start: "", end: "" });
  const [trend, setTrend] = useState([]);
  useEffect(() => {
    const params = range.start ? { start: range.start, end: range.end } : {};
    api.get("/dashboard/trend", { params }).then((r) => setTrend(r.data)).catch(() => setTrend([]));
  }, [range]);
  const data = trend.map((t) => ({ name: t.label || t.bulan, full: t.bulan, pemasukan: t.pemasukan, pengeluaran: t.pengeluaran, net: t.pemasukan - t.pengeluaran }));
  return (
    <div className="card-flat p-4 md:p-6" data-testid={testid}>
      <div className="flex flex-col md:flex-row md:items-start justify-between gap-3 mb-4">
        <div>
          <h3 className="text-base md:text-lg font-semibold text-slate-900" data-testid={`${testid}-title`}>{title} — {rangeLabel(range, "6 Bulan Terakhir")}</h3>
          <p className="text-xs md:text-sm text-slate-500">Bar = pemasukan & pengeluaran {trend[0]?.granularity === "day" ? "harian" : "bulanan"}. Line = {netLabel.toLowerCase()}.</p>
        </div>
        <ChartRangeFilter value={range} onChange={setRange} defaultLabel="6 Bulan Terakhir" testid={`${testid}-filter`} />
      </div>
      <div style={{ width: "100%", height: 300 }}>
        <ResponsiveContainer width="100%" height={300} initialDimension={{ width: 800, height: 300 }}>
          <ComposedChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
            <XAxis dataKey="name" stroke="#64748B" style={{ fontSize: 12 }} minTickGap={8} />
            <YAxis stroke="#64748B" style={{ fontSize: 11 }} tickFormatter={fmtAxis} />
            <Tooltip formatter={(v) => rupiah(v)} labelFormatter={(l, p) => p?.[0]?.payload?.full || l} contentStyle={{ fontSize: 12, borderRadius: 4, borderColor: "#166db4" }} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Bar dataKey="pemasukan" name="Pemasukan" fill="#166db4" radius={[3, 3, 0, 0]} />
            <Bar dataKey="pengeluaran" name="Pengeluaran" fill="#EF4444" radius={[3, 3, 0, 0]} />
            <Line type="monotone" dataKey="net" name={netLabel} stroke="#10B981" strokeWidth={2} dot={{ r: 3 }} />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
